// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__25dRi","values":"Form_values__29fwM"};